export const issueStatusTableConfig = [
  {
    field: 'slNo',
    header: 'SI. No',
    filter: false,
    visible: true,
    defaultPinned: true,
    sortable: false,
    order: 1,
    menuItems: [],
  },
  {
    field: 'issueStatus',
    header: 'Issue Status',
    className: 'issue-status-list-data-column',
    headerClassName: 'issue-status-list-data-column',
    width: 180,
    filter: false,
    visible: true,
    defaultPinned: false,
    sortable: false,
    order: 2,
    menuItems: [],
  },
  {
    field: 'status',
    header: 'Status',
    className: 'issue-status-list-data-column',
    headerClassName: 'issue-status-list-data-column',
    width: 180,
    filter: false,
    visible: true,
    defaultPinned: false,
    sortable: false,
    order: 3,
    menuItems: [],
  },
  {
    field: 'action',
    header: 'Action',
    className: 'issue-status-list-data-column issue-status-list-action-column',
    headerClassName: 'issue-status-list-data-column issue-status-list-action-column',
    width: 180,
    exportable: false,
    filter: false,
    visible: true,
    defaultPinned: false,
    sortable: false,
    order: 5,
    menuItems: [],
  },
];
